module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spacer--small"
  }, [_c('div', {
    staticClass: "expressive-wrapper spacer--medium flex"
  }, [_c('div', {
    staticClass: "pointer column--et-refresh button--refresh center",
    on: {
      "click": _vm.animate
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/expressive-type/refresh.svg",
      "alt": "refresh"
    }
  })]), _vm._v(" "), _c('expressive-type-sub-section', {
    attrs: {
      "name": _vm.kr.name,
      "alt": _vm.name,
      "lang": 'kr',
      "texts": _vm.texts,
      "type-index": _vm.typeIndex,
      "bus": _vm.bus,
      "blurring": _vm.blurring
    }
  }), _vm._v(" "), _c('expressive-type-sub-section', {
    attrs: {
      "name": _vm.en.name,
      "alt": _vm.name,
      "lang": 'en',
      "texts": _vm.texts,
      "type-index": _vm.typeIndex,
      "bus": _vm.bus,
      "blurring": _vm.blurring
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "clear",
    class: !_vm.isLast && 'rule spacer--medium'
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03543b54","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExpressiveTypeSection.vue
// module id = 133
// module chunks = 0